// select distinct background from gift_subscriptions
export const GC_1 = 'gc-1';
